<script lang="tsx" setup>
defineProps<{
  border?: boolean
}>()
</script>

<template>
  <section class="px-4 mt-8 pt-4" :class="{ 'border-t': border }">
    <slot />
  </section>
</template>
